import { Appointments } from '@devexpress/dx-react-scheduler-material-ui';
import { useTheme } from '@mui/material/styles';
import isBefore from 'date-fns/isBefore';
import React from 'react';

import useRoutines from '@hooks/useRoutines';

import type { RoutineEvent } from '@models/routine';

import { AppointmentWrapper } from './Appointment.style';

/**
 * Coloured Appointment based on routine completion status
 */
const Appointment: React.FC<Appointments.AppointmentProps> = ({
  children,
  ...restProps
}) => {
  const { data } = restProps;
  const routineEvent = data as RoutineEvent;
  const { startDate } = routineEvent;
  const upcoming = isBefore(new Date(), new Date(startDate));
  const theme = useTheme();
  const style: React.CSSProperties = {
    borderRadius: '7px',
    backgroundColor: theme.palette.background.paper,
    borderRight: `4px solid ${theme.palette.primary.main}BB`,
    boxShadow: `${theme.shadows[6]}`,
    color: theme.palette.text.primary,
  };
  const { isRoutineComplete } = useRoutines();
  const done = isRoutineComplete(routineEvent);
  if (!upcoming) {
    if (done) {
      style.color = theme.palette.success.main;
      style.borderRight = `4px solid ${theme.palette.success.main}BB`;
    } else {
      style.color = theme.palette.error.main;
      style.borderRight = `4px solid ${theme.palette.error.main}BB`;
    }
  }
  return (
    <Appointments.Appointment {...restProps} style={{ ...style }}>
      <AppointmentWrapper color={style.color}>{children}</AppointmentWrapper>
    </Appointments.Appointment>
  );
};

export default Appointment;
